<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: 1fr 1fr; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item label="房源编号" prop="room_num"><br>
				<el-select style="width: 100%;" v-model="inputmodel.room_num" placeholder="请选择房间" @change="changeselect">
					<el-option v-for=" item in options" :key="item.id" :label="item.room_num" :value="item.room_num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>

			<el-form-item label="订单类型" prop="type"><br>
				<el-radio v-model="inputmodel.type" label="">全部</el-radio>
				<el-radio v-model="inputmodel.type" label="1">水费</el-radio>
				<el-radio v-model="inputmodel.type" label="2">电费</el-radio>
				<el-radio v-model="inputmodel.type" label="3">房租</el-radio>
				<el-radio v-model="inputmodel.type" label="4">押金差额</el-radio>
			</el-form-item>
			<el-form-item label="支付状态" prop="pay_status"><br>
				<el-radio v-model="inputmodel.pay_status" label="">全部</el-radio>
				<el-radio v-model="inputmodel.pay_status" label="0">待支付</el-radio>
				<el-radio v-model="inputmodel.pay_status" label="1">已支付</el-radio>
			</el-form-item>
			<el-form-item label="开始日期" prop="start_time"><br>
				<el-date-picker style="width: 100%;" v-model="inputmodel.start_time" type="date" placeholder="选择日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="结束日期" prop="end_time"><br>
				<el-date-picker style="width: 100%;" v-model="inputmodel.end_time" type="date" placeholder="选择日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
			</el-form-item>

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		bill_export,
		house_list,
		user_get_rent
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '用户姓名',
					model: 'np'
				}],
				inputmodel: {
					type: '',
					room_num: '',
					np: '',
					pay_status: '',
					start_time: '',
					end_time: '',
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 9999999999,
					rent_status: '0'
				}
			}
		},
		methods: {
			qx(i) {
				// 处理 start_time：如果是 null，设为空字符串
				this.inputmodel.start_time = this.inputmodel.start_time === null ? "" : this.inputmodel.start_time;

				// 处理 end_time：如果是 null，设为空字符串
				this.inputmodel.end_time = this.inputmodel.end_time === null ? "" : this.inputmodel.end_time;

				// 处理 room_num：如果是 '全部'，设为空字符串
				this.inputmodel.room_num = this.inputmodel.room_num === '全部' ? "" : this.inputmodel.room_num;
				console.log(this.inputmodel);
				if (i != 1) {
					bill_export(this.inputmodel).then(res => {
						const blob = res;
						// 创建下载链接
						const url = window.URL.createObjectURL(blob);
						const a = document.createElement('a');
						a.href = url;

						// 设置下载的文件名（从响应头获取）
						const contentDisposition = '';
						let fileName = 'download.bin';

						fileName = '账单.xlsx';


						a.download = fileName;
						document.body.appendChild(a);
						a.click();

						// 清理
						window.URL.revokeObjectURL(url);
						document.body.removeChild(a);
						// this.Messages(res)
						// if (res.status == 200) {
						this.inputmodel = {
							type: '',
							room_num: '',
							np: '',
							pay_status: '',
							start_time: '',
							end_time: '',
						}
						this.$emit('changedia', false)
						this.$parent.$parent.$parent.contractlistcontractlist();
						// }
					})

				} else {
					this.inputmodel = {
							type: '',
							room_num: '',
							np: '',
							pay_status: '',
							start_time: '',
							end_time: '',
						},
						this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				user_get_rent().then(res => {
					const _res = res.data
					_res.unshift({
						room_num: '全部',
						id: '',
						name: ''
					})
					this.options = _res
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号
				if (value == '全部') {
					this.inputmodel.np = ''
					return
				}
				const fieldsToUpdate = ['user_name'];
				console.log('是被选中的房间号', value);
				// 查找对应的 item
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);

					house_list({
						room_num: value
					}).then(res => {
						const {
							name,
							rent
						} = res.data.list[0];
						console.log(res);
						this.inputmodel.np = name
						// this.inputmodel.money = rent
					});
				}
			},
		},
		created() {
			// for (let item in this.inputmodel) {
			// 	this.rules[`${item}`] = [{
			// 		required: true,
			// 		message: '不能为空',
			// 		trigger: 'blur'
			// 	}]
			// };
			this.getList()
		},

	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>